import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setAccessToken, setClientCountryCode } from '../Store/authSlice';
import { setStates, setOTPPage, setAfterVerifiedRoute } from '../Store/commonSlice';
import { triggerToast } from '../Toaster';
import useApi from '../useApis';
import { toast } from 'react-toastify';
import { updateUser, setClientSideCellNumber } from '../Store/authSlice';
import useSignIn from './useSignin';

const useSignup = () => {
  const { signIn } = useSignIn();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [otp, setotp] = useState('');
  const [loading, setLoading] = useState(false);
  const [otpVerified, setOtpVerified] = useState(undefined);
  const api = useApi();

  const clientSideCellNumber = useSelector((state) => state?.authReducer);
  const generateOtpForSignup = async (params, onCancel) => {
    setLoading(true);
    const response = await api?.generateOtpForSignup(params);
    if (response?.data?.headers?.code === 200) {
      //set Otp
      dispatch(setClientSideCellNumber(params?.cellNumber));
      dispatch(setClientCountryCode(params?.countryCode));
      setotp(response?.data?.body?.otp);
      dispatch(setOTPPage(true));
      // set data in redux by calling setAccessToken()
      if (typeof onCancel === 'function') {
        onCancel();
      }
      dispatch(setAccessToken(response?.data?.body));
      toast.success('OTP sent successfully');
      //here the access token comes on the basis of accessToken we set the otp page will open

      dispatch(setAfterVerifiedRoute('/otp-verification'));
      navigate('/otp-verification');
    } else {
      // dispatch(setOTPPage(false));
      // dispatch(setAfterVerifiedRoute(''));
      toast.error(response?.data?.headers?.msg, 'error');
    }
    setLoading(false);
  };

  const verifyOtpForSignup = async (params, onCancel) => {
    setLoading(true);
    const response = await api?.verifyOtpForSignUp(params);

    if (response?.data?.headers?.code === 200) {
      //here we off the our verify token state  on the basis os this we can't access
      //verify-token api
      if (typeof onCancel === 'function') {
        onCancel();
      }
      dispatch(setAccessToken(response?.data?.body));

      setOtpVerified(true);
      if (response?.data?.body?.states) {
        /*If the states field comes means that it journey start from signup and we 
        further proceed to the signup steps
        otherwise go to the else block for navigating forgot password
        */
        dispatch(setStates(response?.data?.body?.states));

        navigate('/signup-steps');
      } else {
        navigate('/forgot-password');
      }
    } else {
      setOtpVerified(false);
    }
    setLoading(false);
  };

  //this api also use for set password or pin code in first time
  const forgotPassword = async (params) => {
    setLoading(true);
    const response = await api?.forgotPassword(params);
    if (response?.data?.headers?.code === 200) {
      triggerToast('Pin code set successfully', 'success');
      navigate('/');
      setLoading(false);
      return true;
    } else {
      triggerToast(response?.data?.headers?.msg, 'error');
    }
    setLoading(false);
  };

  const resetPassword = async (params, onSuccess) => {
    setLoading(true);
    // /generate-otp-forgot
    const response = await api?.resetPassword(params);
    if (response?.data?.headers?.code === 200) {
      dispatch(setAccessToken(response?.data?.body));
      dispatch(setOTPPage(true));
      toast.success('OTP sent successfully');
      if (typeof onSuccess === 'function') onSuccess();
    } else {
      toast.error(response?.data?.headers?.msg, 'error');
    }
    setLoading(false);
  };

  const registerDoctor = async (params) => {
    setLoading(true);
    const response = await api?.registerDoctor(params);
    if (response?.data?.headers?.code === 200) {
      await signIn(
        {
          cellNumber: clientSideCellNumber?.clientSideCellNumber,
          countryCode: clientSideCellNumber?.clientSideCountryCode,
          password: params?.password,
          deviceToken: 'string',
          version: 'v2.0.1'
        },
        () => {
          dispatch(setClientSideCellNumber(''));
          dispatch(setClientCountryCode(''));
        }
      );
      // toast.success('Doctor Signup successfully');
      // navigate('/');
      return true;
    } else {
      toast.error(response?.data?.headers?.msg);
    }
    setLoading(false);
  };

  const registerPA = async (params) => {
    setLoading(true);
    const response = await api?.registerPA(params);
    if (response?.data?.headers?.code === 200) {
      triggerToast('PA Signup successfully', 'success');
      return true;
    } else {
      triggerToast(response?.data?.headers?.msg, 'error');
    }
    setLoading(false);
  };
  return {
    loading,
    otp,
    forgotPassword,
    generateOtpForSignup,
    verifyOtpForSignup,
    otpVerified,
    registerDoctor,
    registerPA,
    resetPassword
  };
};

export default useSignup;
